import $ from 'jquery';
import PayLaterBaseMessage from "./PayLaterBaseMessage";

class PayLaterMiniCartMessage extends PayLaterBaseMessage {

    constructor(props) {
        super(props);
        this.cart = props.cart;
    }

    initialize() {
        this.actions.addAction('fragments_changed', this.createMessage.bind(this));
        super.initialize();
    }

    getMessageContainer() {
        let el = null;
        $('#wc-ppcp-minicart-msg').remove();
        switch (this.getSetting('miniCartLocation')) {
            case 'cart_total':
                el = document.querySelector('.woocommerce-mini-cart__total');
                $(el).after('<p class="wc-ppcp-minicart-msg__container"><span id="wc-ppcp-minicart-msg"></span></p>');
                break;
            case 'checkout':
                el = document.querySelector('.woocommerce-mini-cart__buttons .checkout');
                $(el).after('<span id="wc-ppcp-minicart-msg"></span>');
                break;

        }
        if (el) {
            return document.getElementById('wc-ppcp-minicart-msg');
        }
        return document.querySelector('.woocommerce-mini-cart__total');
    }

    showContainer(container) {
        $(container).show();
    }

    hideMessage(container) {
        $(container).hide();
    }

    getTotal() {
        return this.cart.getTotal();
    }

    getPlacement() {
        return 'cart';
    }
}

export {
    PayLaterMiniCartMessage
}